angular.module('dental')
	.directive('input', [function () {
		return {
			restrict: 'A',
			require: '?ngModel',
			link: function ($scope, $element, $attrs, ngModel) {
				let $container = $element.parent('.input');

				if (!$container.hasClass('input')) {
					$container = $element.parentsUntil('.input').parent();
				}

				// in case input with value attribute
				if ($element.attr('value') && $element.attr('value').length && ngModel) {
					ngModel.$setViewValue($element.attr('value'));
					ngModel.$commitViewValue();
				}

				$scope.$watch($attrs.ngModel, (newVal, oldVal) => {
					if ($attrs.type !== 'file' && newVal !== oldVal && $attrs.type !== 'date') {
						$element.trigger('change');
					}

					if (newVal || ngModel && ngModel.$viewValue) {
						$container.addClass('input_hasContent');
						$container.removeClass('input_showPlaceholder');
					} else {
						$container.removeClass('input_hasContent');
						$container.addClass('input_showPlaceholder');
					}
				});

				// in case preset debounce
				$element.on('blur', () => {
					let val = $element.val();
					if (val.length) {
						$container.addClass('input_hasContent');
					} else {
						$container.removeClass('input_hasContent');
					}
				});

				$element.on('focus', () => {
					let val = $element.val();
					if (val.length === 0) {
						$container.addClass('input_showPlaceholder');
					} else {
						$container.removeClass('input_showPlaceholder');
					}
				});

				if (ngModel) {
					ngModel.$parsers.unshift(value => {
						if (value && value.length) {
							$container.removeClass('input_showPlaceholder');
							$container.addClass('input_hasContent');
						} else {
							$container.addClass('input_showPlaceholder');
							$container.removeClass('input_hasContent');
						}
						return value;
					});
				}

				if ($('html').hasClass('ie') && $element.attr('placeholder')) {
					let placeholder = $element.attr('placeholder');
					$element.removeAttr('placeholder');
					$('<div>', {
						class: 'input__placeholder',
						text: placeholder
					}).appendTo($container);
				}
			}
		};
	}]);
